<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.1665 10H15.8332" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
